/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Menu, Tooltip } from "antd";
import { menuItems } from "../../../config/sideMenuList";

import { ReactComponent as CashIcon } from "../../../assests/images/sidebar/retailIcon.svg";

import { ReactComponent as CashIconFilled } from "../../../assests/images/sidebar/retailFilledIcon.svg";
import { motion } from "framer-motion";

const { GET_ALL_PINCODES, COMMON_FEATURE, SHOW_RETAILBY_ID } = urls;

import "./style.scss";
import API from "../../../api";
import urls from "../../../api/urls";
import constants from "../../../constants/constants";
import useCustomNavigate from "../../customNavigationHook";

const { ROLES } = constants;
const { CP_ADMIN, HO_ADMIN, HUB_ADMIN, CP_OPERATOR, CP_BOOKINGONLY } = ROLES;

const SideMenuItems = ({
  visibleDrawer,
  setMenuSideBarVisible,
  setActiveSideTab,
}) => {
  const history = useLocation();
  const navigate = useCustomNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [open, setOpen] = useState(false);
  const [activeKey, setActiveKey] = useState(["1"]);
  const [updateSideMenuList, setUpdateSideMenuList] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const currentEnv = process.env.REACT_APP_ENV;
  // const store = currentEnv == "qa" ? sessionStorage : localStorage;
  const store = sessionStorage;
  const role = JSON.parse(localStorage.getItem("userinfo"))?.roles;
  useEffect(() => {
    const setSideMenu = () => {
      const accountDetails = JSON.parse(localStorage.getItem("userinfo"));
      let newList = menuItems.filter(
        (item) =>
          item.role === "" ||
          item.role.some((e) => accountDetails?.roles?.includes(e))
      );

      // const dashShowRetail = localStorage.getItem("showRetail");

      // if (dashShowRetail == "true") {
      //   newList?.splice(1, 0, {
      //     active: "2",
      //     icon: CashIcon,
      //     fillIcon: CashIconFilled,
      //     title: "Retail Booking",
      //     id: "cash-booking",
      //     route: "/retail-booking",
      //     role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
      //   });
      // }
      setUpdateSideMenuList([...newList]);
    };
    setSideMenu();
  }, []);

  function findParentMenuItem(path, menuItems) {
    for (const child of menuItems) {
      if (child.route === path) {
        return child;
      }
    }
    return null; // Return null if no match is found
  }

  useEffect(() => {
    let key = updateSideMenuList.find(
      (it) => it.route === history.pathname
    )?.active;

    updateSideMenuList.map((it, index) => {
      if (it.route === history.pathname) {
        setActiveIndex(index);
      } else if (it.children) {
        const data = findParentMenuItem(history.pathname, it.children);
        if (data) {
          setActiveIndex(index);
          setActiveKey([it.active]);
        }
      }
      return 0;
    });

    if (key !== undefined) {
      store.setItem("side_active", key);
      setActiveKey([key]);
    } else {
      // const item = findParentMenuItem(history.pathname, menuItems);
      let newKey = store.getItem("side_active");
      // setActiveKey([newKey]);
    }
  }, [history, updateSideMenuList]);

  const onClickHandle = (title, route, active, directReRoute, item, index) => {
    store.removeItem("manifestedId");

    if (title === " Retail Booking") {
      store.removeItem("details");
      setOpen(false);
    }
    setActiveIndex(index);
    setActiveKey([active]);

    if (route) {
      // Check if the route is an external URL
      if (route.startsWith("http://") || route.startsWith("https://")) {
        // Open external URL in a new tab
        window.open(route, "_blank");
      } else {
        // Use internal navigation for relative routes
        navigate(route);
      }
    } else {
      setMenuSideBarVisible(true);
      setActiveSideTab(item);
    }
  };

  return (
    <div>
      <div className="sidebar">
        <motion.div
          className="moving-bg"
          animate={{
            top: `${activeIndex * 60}px`,
            backgroundColor: visibleDrawer ? "#EBF1FA" : "#F5F8FC",
          }}
          transition={{
            duration: 0.15,
            ease: [0.75, 0, 0.75, 1],
          }}
        >
          <div className="before-after-box top-right">
            <div
              style={{
                backgroundColor: "#2D76D0",
                height: 40,
                width: 40,
                borderRadius: "50%",
                position: "relative",
                top: -20,
                left: -20,
                clipPath: "polygon(50% 50%, 100% 50%, 100% 100%, 50% 100%)",
                border: "none",
              }}
            ></div>
          </div>
          <div className="before-after-box bottom-right">
            <div
              style={{
                backgroundColor: "#2D76D0",
                // backgroundColor: "red",
                height: 40,
                width: 40,
                borderRadius: "50%",
                position: "relative",
                bottom: 0,
                left: -20,
                clipPath: "polygon(50% 50%, 50% 0, 100% 0, 100% 50%)",
                border: "none",
              }}
            ></div>
          </div>
        </motion.div>
        {role.includes(CP_ADMIN) &&
        currentEnv === "qa" &&
        !JSON.parse(localStorage.getItem("isEnableCP"))
          ? ""
          : updateSideMenuList.map((item, index) => {
              return (
                <div
                  key={index}
                  className="icon-container"
                  onClick={() => {
                    onClickHandle(
                      item.label,
                      item.route,
                      item.active,
                      item.directReRoute,
                      item,
                      index
                    );
                  }}
                >
                  <Tooltip
                    placement="rightTop"
                    title={item.label}
                    mouseLeaveDelay={0}
                  >
                    <div
                      style={{
                        position: "relative",
                        width: "25px",
                        height: "25px",
                      }}
                    >
                      {React.cloneElement(item.icon, {
                        style: {
                          width: "25px",
                          height: "25px",
                          position: "absolute",
                          opacity: activeKey[0] === item.active ? 1 : 0,
                          transition: "opacity 0.3s ease-in-out",
                        },
                      })}
                      {React.cloneElement(item.fillIcon, {
                        style: {
                          width: "25px",
                          height: "25px",
                          position: "absolute",
                          opacity: activeKey[0] === item.active ? 0 : 1,
                          transition: "opacity 0.3s ease-in-out",
                        },
                      })}
                    </div>
                  </Tooltip>
                </div>
              );
            })}
      </div>
    </div>
  );
};

export default SideMenuItems;
